<template>
  <div class="float_fixd" style="z-index:999;" v-if="photoVisible == true">
   
    <div class=" float_window">

      <div class="see_img">
        <img class="img_content " :src="seePhoto">
      </div>
       <div class="close">
      <i class="el-icon-close text-red"></i>
    </div>
    </div> 
    
  </div>
</template>
<script>
export default {
  props:{
    seePhoto:{
      type: String,
      default: ()=> {
        return ''
      }
    },
    photoVisible: {
      type: Boolean,
      default: ()=> {
        return false
      }
    }
  },
}
</script>
<style lang="scss" scoped>
    .float_fixd{
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      .close{
        position: absolute;
        right: 10%;
        top: 10%;
      }
      .float_window{
        position: absolute;
        width: 100vw;
        height: 100vh;
        background-color: rgba($color: #000000, $alpha: 0.8);
        z-index: 9999;
        .see_img{
          height: 100%;
          width: 24rem;
          display: flex;
          justify-content: center;
          align-items: center;
          .img_content{
            width: 100%;
          }
        }
      }
    }
</style>